module.exports = __webpack_public_path__ + "static/contact-e49e07cb959d9a4a34cd1de537cd5e17.jpg";